import { TFunction } from 'next-i18next'

import { BookingApprovalStatus, ShipmentStatus, TIME_STAMP_FIELDS } from '@shared/const'

import { SlotCreator, User } from '@shared-types/domain'
import { TimestampValue, TimestampValueKey } from '@shared-types/shipments'
import { Optional } from '@shared-types/util'

export const getApprovalActionText = (
  status: BookingApprovalStatus,
  t: TFunction,
  bookingApprovalsEnabled?: boolean
) => {
  const statuses = {
    [BookingApprovalStatus.APPROVED]: t('Approve'),
    [BookingApprovalStatus.PENDING]: t('Unapprove'),
    [BookingApprovalStatus.REJECTED]: bookingApprovalsEnabled ? t('Reject') : t('Remove booking'),
  }

  return statuses[status]
}

export const getBookingCreatorFromUser = (user: User): SlotCreator => {
  const nameParts: string[] = [user.first_name, user.last_name]
  return {
    email: user.email,
    name: nameParts.join(' ').trim() || user.email.split('@')[0],
    user_id: user._id,
    phone: '',
  }
}

export const sumByObjectKey = <T>(array: T[], key: keyof T, initialValue?: number): number => {
  return array.reduce((total, current) => total + Number(current[key]), initialValue || 0)
}

export const getShipmentStatusTimestampKey = (
  shipmentStatus: ShipmentStatus
): Optional<TimestampValue> => {
  switch (shipmentStatus) {
    case ShipmentStatus.CHECKED_IN: {
      return TIME_STAMP_FIELDS.CHECKED_IN
    }
    case ShipmentStatus.DELIVERED: {
      return TIME_STAMP_FIELDS.UNLOAD_COMPLETE_AT
    }
    case ShipmentStatus.PARTIALLY_RECEIVED:
      return TIME_STAMP_FIELDS.PARTIAL_UNLOAD_COMPLETE_AT
    case ShipmentStatus.REJECTED: {
      return TIME_STAMP_FIELDS.REJECTED_AT
    }
    case ShipmentStatus.AT_RAMP: {
      return TIME_STAMP_FIELDS.TRUCK_ARRIVED_AT
    }
    case ShipmentStatus.EXITED: {
      return TIME_STAMP_FIELDS.EXITED_AT
    }
    case ShipmentStatus.CANCELLED: {
      return TIME_STAMP_FIELDS.CANCELLED_AT
    }
  }
}

export const getShipmentStatusTimestampByKey = (
  timestampKey: TimestampValueKey
): Optional<TimestampValue> => {
  const foundTimestamp = Object.values(TIME_STAMP_FIELDS).find(
    (timestamp) => timestamp.key === timestampKey
  )
  return foundTimestamp
}
